import { h } from 'preact';
import { connect } from 'redux-zero/preact';

import config from '../../config.json';

const mapToProps = ({debug, etest, devMode }) => ({ debug, etest, devMode });

const Debug = (props) => {
    const { debug, devMode } = props;

    const dataDebug = props.etest.debug;

    const isDevelopmentMode = () => {
        return config.app_env == 'development' && (debug == 'true' && devMode == 'true');
    };

    return (
        isDevelopmentMode() && props.etest.debug &&
        <div className="et-max-w-md et-mx-auto">
            <div class="neo-card et-mb-2">
                <div className="neo-card-header et-border-b et-border-gray-300">
                    <h3>Debug</h3>
                </div>
                <div className="neo-card-body debug">
                    <div className="et-flex et-justify-between">
                        <div>Item ID</div>
                        <div>{dataDebug.item_id}</div>
                    </div>
                    <div className="et-flex et-justify-between">
                        <div>Level</div>
                        <div>{dataDebug.flow}</div>
                    </div>
                    <div className="et-flex et-justify-between">
                        <div>Group</div>
                        <div>{dataDebug.group}</div>
                    </div>
                    <div className="et-flex et-justify-between">
                        <div>Correct Answer</div>
                        <div>{dataDebug.response}</div>
                    </div>
                    <div className="et-flex et-justify-between">
                        <div>Total Correct</div>
                        <div>{dataDebug.total_correct}</div>
                    </div>
                    <div className="et-flex et-justify-between">
                        <div>Total Incorrect</div>
                        <div>{dataDebug.total_incorrect}</div>
                    </div>
                    <div className="et-flex et-justify-between">
                        <div>Skills</div>
                        <div>{dataDebug.skills}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default connect(mapToProps, null)(Debug)